import { render, staticRenderFns } from "./NuovoAlertPaziente.vue?vue&type=template&id=4db041e9&"
import script from "./NuovoAlertPaziente.vue?vue&type=script&lang=js&"
export * from "./NuovoAlertPaziente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports